<button
  #button
  type="button"
  [disabled]="disabled()"
  [class]="buttonClasses()"
  (click)="submit()"
>
  @if (iconLeft()) {
    <div>
      <svg-icon [src]="iconLeft()" [svgClass]="iconClasses()"></svg-icon>
    </div>
  }
  @if (label()) {
    <div>
      <span class="font-body text-sm font-semibold leading-lg">{{
        label()
      }}</span>
    </div>
  }
  @if (iconRight()) {
    <div>
      <svg-icon [src]="iconRight()" [svgClass]="iconClasses()"></svg-icon>
    </div>
  }
</button>
